
import React, { Component } from 'react'
import { Row, Col, Button, Divider, Icon, Table, message, Select, Input, Modal, DatePicker  } from 'antd'
import { connect } from 'react-redux';
import { CSVLink  } from 'react-csv';
import moment from 'moment';
import $ from 'jquery';

import NewLeaveA from './childs/new.leave'

import { upload_files, 
        get_users, 
        get_leave_type, 
        save_leave, 
        get_leave, 
        delete_leave,
        set_leave_type,
        set_leave_dates,
        set_document } from './actions/leaves.action'

import './style.css';

const dateFormat = 'YYYY/MM/DD';
const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
const Option = Select.Option;
const confirm = Modal.confirm;

class LeavesSummary extends Component {

    constructor( props ){

        super( props );

        this.state = {
            data: [],
            visible: false,
            attach_loader: false,
            attachment: '',
            user_list: [],
            leave_type_list: [],
            leave_type_filter: [{ text: 'None', value: 'None' }],
            approved_filter:[
                { text: 'Pending', value: '0' },
                { text: 'Approved', value: '1' },
            ],
            current_id: 0,
            download_csv: []
        }

        this.handleNewLeave = this.handleNewLeave.bind( this );
        this.handleCancelModal = this.handleCancelModal.bind( this );
        this.handleUpload_files = this.handleUpload_files.bind( this );
        this.handleSubmitNewLeave = this.handleSubmitNewLeave.bind( this );
        this.getColumnSearchProps = this.getColumnSearchProps.bind( this );
        this.handleDeleteLeave = this.handleDeleteLeave.bind( this );
        this.handleLeaveType = this.handleLeaveType.bind( this );
        this.handleLeaveDates = this.handleLeaveDates.bind( this );
        this.handleAttachment = this.handleAttachment.bind( this );
        this.handleUpdateAttach = this.handleUpdateAttach.bind( this );
        this.DateDiff = this.DateDiff.bind( this );

    }

    handleUpdateAttach( leave_id, attach ){
        this.props.set_document( leave_id, attach );
    }

    handleAttachment( e, leave_id ){
        var fdata = new FormData();
        // let user = getCookie('dv_hrms_user').split(',');
        // var user_id =  user[1];

        this.setState({ loader: true });

        if( e.target.files.length>0 ){
            $.each( e.target.files, function( i, file ){

                if( file.size >= 524288000 ){
                    message.error( "File Size too Big", "error" );
                    return false;
                }
                
                fdata.append( "file"+[i], file );
                // fdata.append( "user_id", user_id );

            });
        }
        
        this.props.upload_files( fdata );
        this.setState({ current_id: leave_id })
    
    }

    handleLeaveDates( dateString, leave_id ){
        this.props.set_leave_dates( leave_id, dateString[0], dateString[1] )
    }

    handleLeaveType( leave_id, leave_type_id ){
        this.props.set_leave_type( leave_id, leave_type_id );
    }

    handleDeleteLeave( leave_id ){
        let self = this;

        confirm({
            title: 'Do you Want to delete this Leave?',
            onOk() {
                self.props.delete_leave( leave_id );
            },
            onCancel() {
                // Nothing
            },
        });

    }

    handleSubmitNewLeave( data ){
        this.props.save_leave( data );
    }

    componentWillMount(){
        let self = this;

        self.props.get_users();
        self.props.get_leave_type();

        window.setTimeout( ()=> { 
            self.props.get_leave();
        },1000)

    }

    handleUpload_files( file ){
        this.props.upload_files( file );
    }

    handleCancelModal( value ){
        this.setState({ visible: JSON.parse( value ) });
    }

    handleNewLeave(){
        this.setState({ visible: true });
    }

    componentWillReceiveProps( nextProps ){
        
        if( nextProps.leave_admin.length !== 0 ){

            if( nextProps.leave_admin.STATUS.CODE === "400" &&
                nextProps.leave_admin.STATUS.MESSAGE === "Error: ppt, pptx ,pdf, docx, png, jpg, gif, ZIP, RAR files only." ){
                message.error( nextProps.leave_admin.STATUS.MESSAGE );
                this.setState({
                    attach_loader: false,
                    attachment: ''
                });
            }

            if( nextProps.leave_admin.STATUS.CODE === "400" &&
                nextProps.leave_admin.STATUS.MESSAGE === "The file name already exists, Please Change File Name" ){
                message.error( nextProps.leave_admin.STATUS.MESSAGE );
                this.setState({
                    attach_loader: false,
                    attachment: ''
                });
            }

            if( nextProps.leave_admin.STATUS.CODE === "200" &&
                nextProps.leave_admin.STATUS.MESSAGE === "File Uploaded" ){

                if( this.state.current_id !== 0 ){

                    this.handleUpdateAttach( this.state.current_id, nextProps.leave_admin.OUTPUT.DATA );
                    this.setState({ current_id: 0 });

                } else {

                    this.setState({
                        attach_loader: false,
                        attachment: nextProps.leave_admin.OUTPUT.DATA });

                }

            }

            if( nextProps.leave_admin.STATUS.CODE === "200" &&
                nextProps.leave_admin.STATUS.MESSAGE === "Get Employee List" ){
                this.setState({ user_list: nextProps.leave_admin.OUTPUT.DATA });
            }

            if( nextProps.leave_admin.STATUS.CODE === "200" &&
                nextProps.leave_admin.STATUS.MESSAGE === "Successfully Listed Leave Type" ){

                this.setState({ leave_type_list: nextProps.leave_admin.OUTPUT.DATA });

                if( nextProps.leave_admin.OUTPUT.DATA ){

                    let data_temp = [];
                
                    nextProps.leave_admin.OUTPUT.DATA.map( (item, k) => {
                        data_temp.push( { text: item.leave_type_name, value: item.leave_type_id } );
                    });
            
                    this.setState({
                        leave_type_filter: data_temp
                    });

                }

            }

            if( nextProps.leave_admin.STATUS.CODE === "200" &&
                nextProps.leave_admin.STATUS.MESSAGE === "Successfully Saved leave" ){
                window.location.reload();
            }

            if( nextProps.leave_admin.STATUS.CODE === "200" &&
                nextProps.leave_admin.STATUS.MESSAGE === "Successfully Listed Leaves" ){
                this.setState({ data: nextProps.leave_admin.OUTPUT.DATA });

                let temp = [];
                nextProps.leave_admin.OUTPUT.DATA.map( (item, k) => {

                    let stack = {
                        full_name: item.full_name,
                        leave_name: item.leave_name,
                        from_date: item.from_date,
                        to_date: item.to_date,
                        approved: ( item.approved === '0' ) ? 'Pending': 'Approved',
                        reason: item.reason 
                    }

                    temp.push( stack );

                })

                this.setState({
                    download_csv: temp
                })


            }

            if( nextProps.leave_admin.STATUS.CODE === "200" &&
                nextProps.leave_admin.STATUS.MESSAGE === "Successfully Deleted Leave" ){
                this.props.get_leave();
            }

            if( nextProps.leave_admin.STATUS.CODE === "200" &&
                nextProps.leave_admin.STATUS.MESSAGE === "Successfully changed Leave type" ){
                this.props.get_leave();
            }

            if( nextProps.leave_admin.STATUS.CODE === "200" &&
                nextProps.leave_admin.STATUS.MESSAGE === "Successfully changed Leave dates" ){
                this.props.get_leave();
            }

            if( nextProps.leave_admin.STATUS.CODE === "200" &&
                nextProps.leave_admin.STATUS.MESSAGE === "Successfully updated new attachment" ){  
                message.success( nextProps.leave_admin.STATUS.MESSAGE );
                this.props.get_leave();
            }

        }

    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                }
        }
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    DateDiff(start, end) {
        
        let date1 = new Date( start );
        let date2 = new Date( end );
        let diffTime = Math.abs(date2 - date1);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

        return diffDays+1;

    }

    render() {

        const headers = [
            {label: "Employee Name",  key: "full_name"},
            {label: "Leave Type", key: "leave_name"},
            {label: "From Date", key: "from_date"},
            {label: "To Date", key: "to_date"},
            {label: "Approved", key: "approved"},
            {label: "Reason", key: "reason"}
        ];

        const leave_types = this.state.leave_type_list.map( (item, i) => <Option key={ item.leave_type_id }>{ item.leave_type_name }</Option> )

        const columns_list = [
            {
                title       : 'Employee Name',
                dataIndex   : 'full_name',
                key         : 'full_name',
                ...this.getColumnSearchProps( 'full_name' )
            },
            {
                title       : 'Leave Type',
                key         : 'leave_type_id',
                width       : '10%',
                render      : data => <Select 
                    onChange={ (value) => this.handleLeaveType( data.leave_id, value ) }
                    defaultValue={ data.leave_type_id } style={{ width: '100%' }}>
                    { leave_types }
                </Select>,
                filters: this.state.leave_type_filter,
                onFilter: ( value, record ) => record.leave_type_id.indexOf(value) === 0,
            },
            {
                title       : 'From - To Date',
                render: ( data ) => <span>
                    <RangePicker 
                        defaultValue={[ moment( data.from_date, dateFormat ), moment( data.to_date, dateFormat ) ]}
                        onChange={ (date, dateString )=> this.handleLeaveDates( dateString, data.leave_id ) } />
                </span>
            },
            {
                title       : 'Reason',
                dataIndex   : 'reason',
                key         : 'reason',
                width       : '20%',
            },{
                title: 'Approved',
                dataIndex: 'approved',
                key: 'approved',
                render: ( data ) => <span>{ ( data === '0' ) ? 'Pending': 'Approved' }</span>,
                filters: this.state.approved_filter,
                onFilter: ( value, record ) => record.approved.indexOf(value) === 0,

            },{
                title: 'Actions',
                render: ( data ) => <span>
                    <Button 
                        onClick={ ()=> this.handleDeleteLeave( data.leave_id ) }
                        icon="delete" type="danger"
                        className="table_delete" />
                    <input type="file" className="table_file"
                        onChange={ ( e )=> this.handleAttachment( e, data.leave_id ) } />

                    { (data.attachment !== '' ) ? <a href={ data.attachment } 
                        target="_blank"><Button icon="download" type="ghost" /></a> : '' }
                        
                </span>
            }
        ];

        return (

            <div className="leaves_wrapper">
                
                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="solution" />
                            &nbsp; Employee Leaves
                        </h2>
                    </Col>
                    <Col span={12}>

                        <CSVLink 
                            headers={headers}
                            filename={"Employee-Leaves.csv"}
                            data={ this.state.download_csv } target="_blank" >
                            <Button className="fl_right mrg_l_10 clearfix" type="default">Download CSV</Button></CSVLink >

                        <Button
                            onClick={ this.handleNewLeave }
                            className="fl_right" type="primary" icon="plus">Add Leave</Button>

                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <Table columns={ columns_list } dataSource={ this.state.data } />
                    </Col>
                </Row>

                <NewLeaveA 
                    onUpload={ this.handleUpload_files } 
                    onCancel={ this.handleCancelModal } 
                    onVisible={ this.state.visible }
                    onLoader={ this.state.attach_loader }
                    onAttachment={ this.state.attachment }
                    employeelist={ this.state.user_list }
                    leavetypelist={ this.state.leave_type_list }
                    onSubmit={ this.handleSubmitNewLeave } />

            </div>

        )
    }
}

function mapStatetoProps( state ){
    return {
        leave_admin: state.leave_admin
    }
}

export default connect( mapStatetoProps, { 
    upload_files, 
    get_users, 
    get_leave_type, 
    save_leave,
    get_leave,
    delete_leave,
    set_leave_type,
    set_leave_dates,
    set_document } )( LeavesSummary );





// WEBPACK FOOTER //
// ./src/pages/leaves_admin/index.js